// Init section function when it's visible, then disable observer
initWhenVisible = function (options) {
  const threshold = options.threshold ? options.threshold : 0;

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (typeof options.callback === 'function') {
            options.callback();
            observer.unobserve(entry.target);
          }
        }
      });
    },
    { rootMargin: `0px 0px ${threshold}px 0px` }
  );

  observer.observe(options.element);
};

function isStorageSupported(type) {
  // Return false if we are in an iframe without access to sessionStorage
  if (window.self !== window.top) {
    return false;
  }

  const testKey = 'elevated:test';
  let storage;
  if (type === 'session') {
    storage = window.sessionStorage;
  }
  if (type === 'local') {
    storage = window.localStorage;
  }

  try {
    storage.setItem(testKey, '1');
    storage.removeItem(testKey);
    return true;
  } catch (error) {
    // Do nothing, this may happen in Safari in incognito mode
    return false;
  }
}

class ProductRecentlyViewed extends HTMLElement {
  constructor() {
    super();

    // We save the product ID in local storage to be eventually used for recently viewed section
    if (isStorageSupported('local')) {
      const productId = parseInt(this.dataset.productId);
      const cookieName = 'elevated:recently-viewed';
      const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');

      // We check if the current product already exists, and if it does not, we add it at the start
      if (!items.includes(productId)) {
        items.unshift(productId);
      }

      // By keeping only the 4 most recent
      window.localStorage.setItem(cookieName, JSON.stringify(items.slice(0, 13)));
    }
  }
}
customElements.define('product-recently-viewed', ProductRecentlyViewed);

if (!customElements.get('recently-viewed-products')) {
  customElements.define(
    'recently-viewed-products',
    class RecentlyViewedProducts extends HTMLElement {
      constructor() {
        super();

        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);

          fetch(this.dataset.url + this.getQueryString())
            .then((response) => response.text())
            .then((text) => {
              const html = document.createElement('div');
              html.innerHTML = text;
              const recommendations = html.querySelector('recently-viewed-products');

              if (recommendations && recommendations.innerHTML.trim().length) {
                this.innerHTML = recommendations.innerHTML;                
              }
            })
            .then(() => {
              if (this.querySelector('.splide')) {
                this.initSlider(this.querySelector('.splide'));
              }
              setTimeout(() => {
                if (this.querySelector('.scroll-animation')) {
                  this.querySelector('.scroll-animation').classList.add('scroll-animation--active');
                }
              }, 500);
            })
            .catch((e) => {
              console.error(e);
            });
        };

        new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 100px 0px' }).observe(this);
      }

      initSlider(target) {
        const splide = new Splide(target, {
          pagination: target.dataset.pagination,
          arrows: target.dataset.navigation,
          perPage: target.dataset.columnsDesktop,
          type: target.dataset.type,
          gap: '1rem',
          perMove: 1,
          keyboard: true,
          pauseOnHover: true,
          pauseOnFocus: true,
          breakpoints: {
            768: {
              type: 'loop',
              perPage: 1,
              padding: { right: '2rem' },
            },
          },
        });
        splide.mount();
      }

      getQueryString() {
        const cookieName = 'elevated:recently-viewed';
        const items = JSON.parse(window.localStorage.getItem(cookieName) || '[]');
        if (this.dataset.productId && items.includes(parseInt(this.dataset.productId))) {
          items.splice(items.indexOf(parseInt(this.dataset.productId)), 1);
        }
        return items
          .map((item) => 'id:' + item)
          .slice(0, 13)
          .join(' OR ');
      }
    }
  );
}
